import { FC } from 'react';
import AddToCalendar from '@culturehq/add-to-calendar';

interface Event {
	id: number;
	title: string;
	date?: string | null; // Make date optional and allow it to be null
	description: string;
	images: { [key: string]: string };
	start_time?: string | null;
	end_time?: string | null;
}

interface EventCardProps {
	event: Event;
	onClick: () => void;
}

const EventCard: FC<EventCardProps> = ({ event, onClick }) => {
	const hasImages = Object.values(event.images).some(url => url !== '');

	// Initialize variables for startsAt, endsAt, and formattedDate
	let startsAt: string | null = null;
	let endsAt: string | null = null;
	let formattedDate: string | null = null;

	if (event.date) {
		// Parse the event date
		const eventDate = new Date(event.date);

		// Format the date as "Wednesday, August 21"
		formattedDate = eventDate.toLocaleDateString('en-US', {
			weekday: 'long',
			month: 'long',
			day: 'numeric',
		});

		// Process the start and end times
		if (event.start_time) {
			startsAt = new Date(`${event.date}T${event.start_time}`).toISOString();
		} else {
			startsAt = eventDate.toISOString();
		}

		if (event.end_time) {
			endsAt = new Date(`${event.date}T${event.end_time}`).toISOString();
		} else {
			endsAt = new Date(new Date(startsAt).getTime() + 60 * 60 * 1000).toISOString();
		}
	} else {
		console.error('Event date is not defined');
	}

	return (
		<div className="fsdpe-calendar-wrapper__views__cards__card">
			<h3>{event.title}</h3>
			<div>
				<span>{formattedDate || 'Date not provided'}</span>
				<span>, </span>
				<span>{event.start_time || 'No start time provided'}</span>
			</div>

			{hasImages && (
				<div className="image-wrapper">
					<img src={event.images.medium} alt={event.title} />
				</div>
			)}
			<div className="fsdpe-calendar-wrapper__views__cards__card__buttons">
				{startsAt && (
					<AddToCalendar
						children={'Add to calendar'}
						event={{
							name: event.title,
							details: event.description,
							location: '', // Optional
							startsAt,
							endsAt,
						}}
					/>
				)}
				<button
					className="fsdpe-calendar-wrapper__views__cards__card__btn"
					onClick={onClick}
				>
					Show Details
				</button>
			</div>
		</div>
	);
};

export default EventCard;
